import { render } from "./PaymentInputsBedPart.vue?vue&type=template&id=3a056d20"
import script from "./PaymentInputsBedPart.vue?vue&type=script&lang=js"
export * from "./PaymentInputsBedPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__